import { render, staticRenderFns } from "./education.vue?vue&type=template&id=2c2bc47a&"
import script from "./education.vue?vue&type=script&lang=js&"
export * from "./education.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports